// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React, { createElement } from "react";
import ReactDOMServer from "react-dom/server";

import * as antd from "antd"; // Will Export All antd-components to User-script

import DivE from "../components/react/DivE.tsx";
import SpanE from "../components/react/SpanE.tsx";
import TextE from "../components/react/TextE.tsx";
import BrE from "../components/react/BrE.tsx";
import classicLink from "../components/react/classicLink.tsx"
import routerLink from "../components/react/routerLink.tsx";
import UserStyle from "../components/react/UserStyle.tsx";
import HTMLMDviewer from "../components/react/HTMLMDviewer.tsx";
import relsRenderer from "../components/react/relsRenderer.tsx";
import approvalRenderer from "../components/react/approvalRenderer.tsx";
import chatRenderer from "../components/react/chatRenderer.tsx";

// Store
import store from "./store.ts";

import AppIcons from "../components/react/AppIcons.tsx";
import dict from "../../../../dict/app";

import type {TuiState} from "../types/uiapp.d.ts";

const {rz} = window;

const getFullPathFromKey = (elKey:string, appState:TuiState) => {
  let fullPath = elKey;
  if (!fullPath || !~fullPath.indexOf("/")) {
    let fnd = false; const allStateKeys = rz.objKeys(appState);
    for (let i = 0; i < allStateKeys.length; i++) {
      // eslint-disable-next-line prefer-destructuring
      if (appState[allStateKeys[i]].key === elKey) { fnd = true; fullPath = appState[allStateKeys[i]].fullPath; break }
    }
    if (!fnd) { return elKey }
  }
  return fullPath || "";
};

// @ts-ignore
if (!window.DivE) window.DivE = DivE; // My easy components
// @ts-ignore
if (!window.SpanE) window.SpanE = SpanE; // My easy components
// @ts-ignore
if (!window.TextE) window.TextE = TextE;
// @ts-ignore
if (!window.BrE) window.BrE = BrE;
// @ts-ignore
if (!window.classicLink) window.classicLink = classicLink;
// @ts-ignore
if (!window.routerLink) window.routerLink = routerLink;
// @ts-ignore
if (!window.UserStyle) window.UserStyle = UserStyle;
// @ts-ignore
if (!window.HTMLMDviewer) window.HTMLMDviewer = HTMLMDviewer;
// @ts-ignore
if (!window.relsRenderer) window.relsRenderer = relsRenderer;
// @ts-ignore
if (!window.approvalRenderer) window.approvalRenderer = approvalRenderer;
// @ts-ignore
if (!window.chatRenderer) window.chatRenderer = chatRenderer;
// @ts-ignore
if (!window.getFullPathFromKey) window.getFullPathFromKey = getFullPathFromKey;

// @ts-ignore
if (!window.antd) window.antd = antd; // Will Export All antd-components to User-script
// @ts-ignore
if (!window.React) window.React = React; // Will Export React.createElement to User-script
// @ts-ignore
if (!window["dict-app"]) window["dict-app"] = dict; // Will Export Dictionary for all available languages
// @ts-ignore
if (!window.getState) {
  // @ts-ignore
  window.getState = (appkey:string, fields?:string[]) => {
    const {ar} = store.getState();
    if (!appkey) { return ar }
    // @ts-ignore
    if (!fields || !fields.length) { return {...ar.uiState[appkey], isSafePtr: ar.cfg.safe} }
    const ans = {};
    fields.forEach((ff: string) => {
      const pth = getFullPathFromKey(ff, ar.uiState[appkey]);
      if (pth && ar.uiState[appkey][pth]) { ans[ff] = ar.uiState[appkey][pth] }
    });
    return ans;
  }; // Will Export Full Redux store (actual for any time)
}
// @ts-ignore
if (!window.getElementsState) {
  // @ts-ignore
  window.getElementsState = ({appState, appkey, fields}:{appkey:string, appState: { [key:string]:any; }, fields: any[]}) => {
    const ans = {}; if (!fields || !fields.length || (!appkey && !appState)) { return ans }
    let aState = appState;
    // @ts-ignore
    if (!appState && appkey) { aState = window.getState(appkey) }
    fields.forEach((ff: string) => {
      const pth = getFullPathFromKey(ff, aState);
      if (pth && aState[pth]) { ans[aState[pth].shortPath || aState[pth].key] = aState[pth] }
    });
    return ans;
  };
}

// Now User can create any React-Icons inside simple javascript
const getIcon = (args:{key?:string, icopath:string, class?:string, className?:string, style?:string, color?:string, bgcolor?:string, tooltip?:string, size?:string | number, gethtml?:boolean}) => {
  const {key, icopath, className, style, color, bgcolor, tooltip, size, gethtml} = args;
  const atrs:{key:string, icopath:string, className?:string, style?:{[key:string]:any}, "uk-tooltip"?:string, attrs: {color?:string, bgcolor?:string, size?:string | number, gethtml?:boolean}} = {
    key: key || icopath, icopath, attrs: {}
  };

  if (style) { atrs.style = rz.parseCSSText(style) }
  if (className || args.class) { atrs.className = className || args.class }
  if (color) { atrs.attrs.color = color }
  if (bgcolor) { atrs.attrs.bgcolor = bgcolor }
  if (size) { atrs.attrs.size = size }
  if (tooltip) { atrs.attrs["uk-tooltip"] = tooltip }
  // if (gethtml) { atrs.attrs.gethtml = gethtml }

  if (gethtml) {
    const htm = ReactDOMServer.renderToStaticMarkup(React.createElement(AppIcons, atrs));
    return htm;
  }

  return React.createElement(AppIcons, atrs);
};
// @ts-ignore
if (!window.getIcon) window.getIcon = getIcon;

const getRoles = (userObject: { login:string, groups:string[] | any[] }, attrs: string) => {
  if (!userObject || !userObject.login || !userObject.groups || !userObject.groups.length) return [];
  const curState = store.getState();
  // @ts-ignore
  const curApp = curState.ar.apps.find((aa) => ((rz.isString(attrs) && aa.key === attrs) || (aa.key === attrs?.rootAttributes?.key))); if (!curApp) return [];
  const curDate = rz.dateToString(new Date(), "YYYY-MM-DD");
  const userRoles:Array<string> = [];
  (curApp?.roles || []).forEach((cr) => {
    (cr?.groups || []).forEach((dbg) => {
      // @ts-ignore
      if (~(userObject.groups as Array<string>).indexOf(dbg.group) && (!dbg.expired || dbg.expired > curDate) && !~userRoles.indexOf(cr.role)) { userRoles.push(cr.role) }
    });
    (cr?.users || []).forEach((dbg) => {
      if (dbg.user.toLowerCase() === userObject.login?.toLowerCase() && (!dbg.expired || dbg.expired > curDate) && !~userRoles.indexOf(cr.role)) { userRoles.push(cr.role) }
    });
  });
  return userRoles;
};

// @ts-ignore
if (!window.getRoles) window.getRoles = getRoles;

// @ts-ignore
if (!window.getGridAPI) { window.getGridAPI = ({appkey, fullPath, gridPath, key}) => new Promise((resolve) => {
  const pp = (fullPath || gridPath || key);
  if (!appkey || !pp) { return resolve(null) }
  const fast = ~pp.indexOf("/");
  if (fast) {
    if (window[appkey] && window[appkey][pp] && window[appkey][pp].getGridAPI) {
      window[appkey][pp].getGridAPI().then((gridAPI) => { resolve(gridAPI) });
    } else { return resolve(null) }
  }
  else {
    // @ts-ignore
    const elements = window.getElementsState({appkey, fields: [fullPath || gridPath || key]});
    if (elements) {
      const objKeys = rz.objKeys(elements);
      if (objKeys && objKeys.length && window[appkey] && window[appkey][elements[objKeys[0]].fullPath] && window[appkey][elements[objKeys[0]].fullPath].getGridAPI) {
        window[appkey][elements[objKeys[0]].fullPath].getGridAPI().then((gridAPI) => { resolve(gridAPI) });
      } else { return resolve(null) }
    } else { return resolve(null) }
  }
}) }

if (!window.getGridRef) { window.getGridRef = ({appkey, fullPath, gridPath, key}) => new Promise((resolve) => {
  const pp = (fullPath || gridPath || key);
  if (!appkey || !pp) { return resolve(null) }
  const fast = ~pp.indexOf("/");
  if (fast) {
    if (window[appkey] && window[appkey][pp] && window[appkey][pp].getGridRef) {
      window[appkey][pp].getGridRef().then((gridRef) => { resolve(gridRef) });
    } else { return resolve(null) }
  }
  else {
    // @ts-ignore
    const elements = window.getElementsState({appkey, fields: [fullPath || gridPath || key]});
    if (elements) {
      const objKeys = rz.objKeys(elements);
      if (objKeys && objKeys.length && window[appkey] && window[appkey][elements[objKeys[0]].fullPath] && window[appkey][elements[objKeys[0]].fullPath].getGridRef) {
        window[appkey][elements[objKeys[0]].fullPath].getGridRef().then((gridRef) => { resolve(gridRef) });
      } else { return resolve(null) }
    } else { return resolve(null) }
  }
}) }

// @ts-ignore
if (!window.getSelectedNodes) { window.getSelectedNodes = ({appkey, fullPath, gridPath, key}) => new Promise((resolve) => {
  // selectedNodes:null | any, checkedNodes:null | any, cellRanges:null | any, selectedRows:null | any, gridAPI:null | any, startRow:number, endRow:number
  const pp = (fullPath || gridPath || key);
  if (!appkey || !pp) { return resolve({selectedNodes: null, checkedNodes: null, cellRanges: null, gridAPI: null, startRow: -1, endRow: -1}) }
  const fast = ~pp.indexOf("/");
  if (fast) {
    if (window[appkey] && window[appkey][pp] && window[appkey][pp].getSelectedNodes) {
      window[appkey][pp].getSelectedNodes().then((ans1) => { resolve(ans1) });
    } else { return resolve({selectedNodes: null, checkedNodes: null, cellRanges: null, gridAPI: null, startRow: -1, endRow: -1}) }
  }
  else {
    // @ts-ignore
    const elements = window.getElementsState({appkey, fields: [fullPath || gridPath || key]});
    if (elements) {
      const objKeys = rz.objKeys(elements);
      if (objKeys && objKeys.length && window[appkey] && window[appkey][elements[objKeys[0]].fullPath] && window[appkey][elements[objKeys[0]].fullPath].getSelectedNodes) {
        window[appkey][elements[objKeys[0]].fullPath].getSelectedNodes().then((ans1) => { resolve(ans1) });
      } else { return resolve({selectedNodes: null, checkedNodes: null, cellRanges: null, gridAPI: null, startRow: -1, endRow: -1}) }
    } else { return resolve({selectedNodes: null, checkedNodes: null, cellRanges: null, gridAPI: null, startRow: -1, endRow: -1}) }
  }
}) }

// @ts-ignore
if (!window.getGridRows) { window.getGridRows = ({appkey, fullPath, gridPath, key}) => new Promise((resolve) => {
  const pp = (fullPath || gridPath || key);
  if (!appkey || !pp) {
    return resolve({
      allNodes: null, filteredAndSortedNodes: null, selectedNodes: null, checkedNodes: null, cellRanges: null,
      allRows: null, filteredAndSortedRows: null, startRow: -1, endRow: -1, gridAPI: null
    });
  }
  const fast = ~pp.indexOf("/");
  if (fast) {
    if (window[appkey] && window[appkey][pp] && window[appkey][pp].getGridAPI) {
      window[appkey][pp].getGridAPI().then((gridAPI) => {
        if (!gridAPI) {
          return resolve({
            allNodes: [], filteredAndSortedNodes: [], selectedNodes: [], checkedNodes: [], cellRanges: [], allRows: [], filteredAndSortedRows: [], startRow: -1, endRow: -1, gridAPI: null
          });
        }
        const cellRanges = gridAPI.getCellRanges(), checkedNodes = gridAPI.getSelectedNodes(), selectedNodes:Array<any> = []; let startRow = -1, endRow = -1, hasRange = false;
        if (cellRanges && cellRanges.length === 1 && cellRanges[0].startRow) {
          startRow = Math.min(cellRanges[0].startRow.rowIndex, cellRanges[0].endRow.rowIndex); endRow = Math.max(cellRanges[0].startRow.rowIndex, cellRanges[0].endRow.rowIndex); hasRange = true;
        }
        const allNodes:Array<any> = []; gridAPI.forEachNode((nn) => { allNodes.push(nn) });
        const allRows = allNodes.filter((nn) => (!nn.group && nn.data)).map((nn) => (nn.data));
        const serverSideDatasource = gridAPI.getGridOption("serverSideDatasource");
        const filteredAndSortedNodes:Array<any> = [];
        if (serverSideDatasource) {
          gridAPI.forEachNode((node) => {
            if (!node.group && node.rowIndex >= startRow && node.rowIndex <= endRow) { selectedNodes.push(node) }
          });
        }
        else {
          gridAPI.forEachNodeAfterFilterAndSort((node) => {
            filteredAndSortedNodes.push(node);
            if (hasRange && !node.group && node.rowIndex >= startRow && node.rowIndex <= endRow) { selectedNodes.push(node) }
          });
        }
        const selectedRows:Array<any> = [];
        const filteredAndSortedRows = filteredAndSortedNodes.filter((nn) => (!nn.group && nn.data)).map((nn) => {
          if (nn.rowIndex >= startRow && nn.rowIndex <= endRow) { selectedRows.push(nn.data) }
          return nn.data;
        });
        // Good Answer
        resolve({
          allNodes, filteredAndSortedNodes, selectedNodes, checkedNodes, cellRanges, allRows, filteredAndSortedRows, startRow, endRow, gridAPI
        });
      });
    }
    else {
      return resolve({
        allNodes: null, filteredAndSortedNodes: null, selectedNodes: null, checkedNodes: null, cellRanges: null, allRows: null, filteredAndSortedRows: null, startRow: -1, endRow: -1, gridAPI: null
      });
    }
  }
  else {
    // @ts-ignore
    const elements = window.getElementsState({appkey, fields: [pp]});
    if (elements) {
      const objKeys = rz.objKeys(elements);
      if (objKeys && objKeys.length && window[appkey] && window[appkey][elements[objKeys[0]].fullPath] && window[appkey][elements[objKeys[0]].fullPath].getGridAPI) {
        window[appkey][elements[objKeys[0]].fullPath].getGridAPI().then((gridAPI) => {
          if (!gridAPI) {
            return resolve({
              allNodes: [], filteredAndSortedNodes: [], selectedNodes: [], checkedNodes: [], cellRanges: [], allRows: [], filteredAndSortedRows: [], startRow: -1, endRow: -1, gridAPI: null
            });
          }
          const cellRanges = gridAPI.getCellRanges(), checkedNodes = gridAPI.getSelectedNodes(), selectedNodes:Array<any> = []; let startRow = -1, endRow = -1, hasRange = false;
          if (cellRanges && cellRanges.length === 1 && cellRanges[0].startRow) {
            startRow = Math.min(cellRanges[0].startRow.rowIndex, cellRanges[0].endRow.rowIndex); endRow = Math.max(cellRanges[0].startRow.rowIndex, cellRanges[0].endRow.rowIndex); hasRange = true;
          }
          const allNodes:Array<any> = []; gridAPI.forEachNode((nn) => { allNodes.push(nn) });
          const allRows = allNodes.filter((nn) => (!nn.group && nn.data)).map((nn) => (nn.data));
          const serverSideDatasource = gridAPI.getGridOption("serverSideDatasource");
          const filteredAndSortedNodes:Array<any> = [];
          if (serverSideDatasource) {
            gridAPI.forEachNode((node) => {
              if (!node.group && node.rowIndex >= startRow && node.rowIndex <= endRow) { selectedNodes.push(node) }
            });
          }
          else {
            gridAPI.forEachNodeAfterFilterAndSort((node) => {
              filteredAndSortedNodes.push(node);
              if (hasRange && !node.group && node.rowIndex >= startRow && node.rowIndex <= endRow) { selectedNodes.push(node) }
            });
          }
          const selectedRows:Array<any> = [];
          const filteredAndSortedRows = filteredAndSortedNodes.filter((nn) => (!nn.group && nn.data)).map((nn) => {
            if (nn.rowIndex >= startRow && nn.rowIndex <= endRow) { selectedRows.push(nn.data) }
            return nn.data;
          });
          // Good Answer
          resolve({
            allNodes, filteredAndSortedNodes, selectedNodes, checkedNodes, cellRanges, allRows, filteredAndSortedRows, startRow, endRow, gridAPI
          });
        });
      } else {
        return resolve({
          allNodes: null, filteredAndSortedNodes: null, selectedNodes: null, checkedNodes: null, cellRanges: null, allRows: null, filteredAndSortedRows: null, startRow: -1, endRow: -1, gridAPI: null
        });
      }
    }
    else {
      return resolve({
        allNodes: null, filteredAndSortedNodes: null, selectedNodes: null, checkedNodes: null, cellRanges: null, allRows: null, filteredAndSortedRows: null, startRow: -1, endRow: -1, gridAPI: null
      });
    }
  }
}) }

// Short console.log
// @ts-ignore
if (!window._d) window._d = console.log;

export default getIcon;
export {getRoles};
